import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqWatcher,
  initialState as rootState,
  makePaginationReducer,
} from '../../../utils/redux';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

const makeRequestConfig = (slug = []) => ({
  endpoint: 'organizations',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'primary_care_providers',
    {
      type: 'payload.query',
      queryParameter: 'query',
      selector: 'query',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    ...slug,
  ],
});

const requestOptions = makeRequestConfig([
  {
    type: 'payload.query',
    queryParameter: 'offset',
    selector: 'offset',
  },
]);

export const consts = createReqConsts(
  'appointment-form',
  'primary-providers-list-request',
  ['LOAD_MORE'],
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'appointment-form',
  'primary-providers-list-lazy-load-request',
);

export const paginationActions = createActions(paginationConsts);

export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
  true,
);

const defaultRequestReducer = makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'total',
});

const initialState = {
  ...rootState,
  count: 0,
  isLastPage: false,
};

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SUCCEED:
      return {
        ...state,
        succeed: true,
        sending: false,
        list:
          state.list && state.list.length !== 0
            ? state.list.concat(payload)
            : payload,
      };

    case consts.ADD_META: {
      const total = get(action.payload, 'total', 0);

      return {
        ...state,
        count: total,
        isLastPage: state.list.length === total,
      };
    }

    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/primary-providers-list.js